const _FALLBACK_FILE_NAME = 'download'

export const promptFileDownload = async (fileContent: Blob, fileName?: string) => {
  try {
    const url = window.URL.createObjectURL(fileContent)
    const a = document.createElement('a')

    a.href = url
    a.download = fileName ?? _FALLBACK_FILE_NAME
    document.body.appendChild(a)
    a.click()

    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  } catch (e) {
    console.error(e)
  }
}
